/**
 * @description 주문현황 및 알림 페이지
 */

import { inject, observer } from "mobx-react";
import { useEffect } from "react";

import SettingDefaultUseOrderView from "./sections/SettingDefaultUseOrderView";
import SettingDefaultUseSoundView from "./sections/SettingDefaultUseSoundView";
import { fn_use_set_type } from "function/FnBodyLayer";
import SettingWrapper from "views/setting/components/wrappers/SettingWrapper";

const SettingDefaultUseView = ({ rootStore }: { rootStore: any }) => {
  const { settingStore, layerStore } = rootStore;

  useEffect(() => {
    settingStore.setSettingUseMenu("use");
    settingStore.setSettingView(false);
  }, [settingStore]);

  const TabsConfig = [
    {
      label: "주문현황 설정",
      isActive: layerStore.getLayerUseSetTypeView === "order",
      isView: true,
      onClick: () => fn_use_set_type(rootStore, "order"),
    },
    {
      label: "알림 설정",
      isActive: layerStore.getLayerUseSetTypeView === "sound",
      isView: true,
      onClick: () => fn_use_set_type(rootStore, "sound"),
    },
  ];

  return (
    <SettingWrapper title="주문현황 및 알림" tabs={TabsConfig} rootStore={rootStore}>
      {layerStore.getLayerUseSetTypeView === "order" ? (
        <SettingDefaultUseOrderView rootStore={rootStore} />
      ) : (
        <SettingDefaultUseSoundView rootStore={rootStore} />
      )}
    </SettingWrapper>
  );
};

export default inject("rootStore")(observer(SettingDefaultUseView));
